// extracted by mini-css-extract-plugin
export default {"deliverySlotsFilter":"styles_deliverySlotsFilter__1QnXB","slotsFilterBar":"styles_slotsFilterBar__k6FhH"};